/**
 * Web-storage keys and events that outlive the React tree.
 *
 * The frontend's `useStorage` hooks own the read/write mechanics, but anything
 * that has to interoperate with them from outside React needs the same key and
 * event name: `storeLocale` writing a locale before the app renders, and e2e
 * tests driving the browser. Keeping both here makes a rename a compile error
 * everywhere instead of a silently broken override.
 */

/** `localStorage` key holding the visitor's preferred `Locale`, as a raw enum string. */
export const USER_LOCALE_KEY = "userLocale"

/**
 * Name of the window event `useStorage` dispatches and listens for to keep hook
 * instances in the same tab in sync (only when `sync` is enabled). The event's
 * `detail` is the deserialized value, not the serialized string.
 */
export const storageEventKey = (key: string): string => `useStorage-${key}`
